import React from "react";
import s from "./pricesTable.scss";
import cx from "classnames";
import { priceFormat } from "Utils/strings";

const headers = [{ label: "basic" }, { label: "professional" }, { label: "enterprise" }];

const formatPricesForTable = (activeTier) => {
  let sizesPrizes = {};

  for (let k in activeTier) {
    if (["basic", "professional", "enterprise"].includes(k)) {
      for (let size in activeTier[k]) {
        if (!sizesPrizes[size]) sizesPrizes[size] = [];

        sizesPrizes[size].push({ amount: `€ ${priceFormat(activeTier[k][size])}` });
      }
    }
  }

  // pad empty spots with "-"
  const totalOptions = Object.values(sizesPrizes).sort((a, b) => b.length - a.length)[0].length;
  for (let size in sizesPrizes) {
    if (sizesPrizes[size].length < totalOptions) {
      for (let i = 0; i <= totalOptions - sizesPrizes[size].length; i++) {
        sizesPrizes[size].unshift({ amount: "-" });
      }
    }
  }

  return sizesPrizes;
};

const CustomTierPricesTable = ({ prices }) => {
  if (!prices) {
    return <div>Caricando...</div>;
  }

  const table = formatPricesForTable(prices);

  return (
    <>
      <div className={s.priceTablesContainer}>
        <table className={cx(s.headerTable, s.customTierPricePlans)}>
          <tbody>
            <tr>
              <td style={{ visibility: "hidden" }}></td>
              {headers.map((h) => (
                <td key={h.label}>
                  <div className={cx(s.priceTableHeader, {})}>{h.label}</div>
                </td>
              ))}
            </tr>
          </tbody>
        </table>

        <table className={cx(s.priceTable, s.basicTable, s.customTierPriceTable)}>
          <tbody>
            {Object.entries(table).map(([size, prices]) => (
              <tr key={size}>
                <td>{size} GB</td>
                {prices.map((price, index) => (
                  <td className={s.amount} key={price.amount + index}>
                    {price.amount}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CustomTierPricesTable;
